import { useEffect, useMemo, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import TableFilter from "src/components/TableFilter";
import { DDSTypes } from "src/modules/3rd-party-management/constants";

const FilteringComponent = ({
    t,
    countries,
    onChange
}) => {
    const [tableFilters, setTableFilters] = useState({
        originCountry: null,
        ddsDeclarationType: null,
        ddsSearch: undefined,
        productName: undefined,
        containerNumber: undefined,
        shipmentNumber: undefined
    });
    const initRef = useRef(false);

    const tableFilterTabs = useMemo(() => {
        const ddsTypes = Object.keys(DDSTypes).map((type) => {
            return {
                id: type,
                name: t(DDSTypes[type].title)
            }
        });

        return [
            {
                type: 'radio_list',
                name: 'originCountry',
                title: 'Country of Origin',
                icon: <i className="ri-global-line" />,
                isLoading: countries.isFetching,
                defaultValue: tableFilters?.originCountry,
                data: countries.data || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.name
                }
            },
            {
                type: 'radio_list',
                name: 'ddsDeclarationType',
                title: t('DDS Declaration Type'),
                icon: <i className="ri-file-list-3-line" />,
                isLoading: countries.isFetching,
                defaultValue: tableFilters?.ddsDeclarationType,
                data: ddsTypes || [],
                searchInListOption: {
                    enabled: true,
                    remote: false
                },
                formatter: (item) => {
                    return item.name
                }
            },
            {
                type: 'search_textbox',
                name: 'ddsSearch',
                title: t('DDS Reference Number'),
                icon: <i className="ri-hashtag" />,
                defaultValue: tableFilters?.ddsSearch,
                options: {
                    placeholder: t('Search'),
                    typingDelay: 750
                }
            },
            {
                type: 'search_textbox',
                name: 'containerNumber',
                title: t('Container Number'),
                icon: <i className="ri-stack-line" />,
                defaultValue: tableFilters?.containerNumber,
                options: {
                    placeholder: t('Search'),
                    typingDelay: 750
                }
            }, 
            {
                type: 'search_textbox',
                name: 'shipmentNumber',
                title: t('Shipment Number'),
                icon: <i className="ri-truck-line" />,
                defaultValue: tableFilters?.shipmentNumber,
                options: {
                    placeholder: t('Search'),
                    typingDelay: 750
                }
            },
            {
                type: 'search_textbox',
                name: 'productName',
                title: t('Search'),
                icon: <i className="ri-terminal-box-line" />,
                defaultValue: tableFilters?.productName,
                options: {
                    placeholder: t('Search by name or lot number'),
                    typingDelay: 750
                },
                displayIndependently: true,
                onFilterChange: (value, { isConvas }) => {
                    !isConvas && setTableFilters((currentState) => ({...currentState, productName: value}))
                }
            }
        ]
    }, [
        tableFilters,

        countries.isFetching,
        countries.data,
        
        t
    ]);

    const onTableFilterOkButtonClicked = (filters, independentTabsData) => {
        if (filters) {
            const result = {}

            if ('originCountry' in filters) {
                result.originCountry =
                    filters.originCountry !== 'all' ? filters.originCountry : undefined
            }

            if ('ddsDeclarationType' in filters) {
                result.ddsDeclarationType =
                    filters.ddsDeclarationType !== 'all' ? filters.ddsDeclarationType : undefined
            }

            if('ddsSearch' in filters) {
                result.ddsSearch = filters.ddsSearch || undefined;
            }

            if('containerNumber' in filters) {
                result.containerNumber = filters.containerNumber || undefined;
            }

            if('shipmentNumber' in filters) {
                result.shipmentNumber = filters.shipmentNumber || undefined;
            }

            if('productName' in filters) { // this is for when convas is open
                result.productName = filters.productName || undefined;
            }

            setTableFilters({
                ...tableFilters,
                ...result
            })
        } else {
            setTableFilters({
                originCountry: null,
                ddsDeclarationType: null,
                ddsSearch: undefined,
                containerNumber: undefined,
                shipmentNumber: undefined,
                productName: independentTabsData?.productName
            })
        }
    }

    useEffect(() => {
        if (!initRef.current) {
            initRef.current = true;
            return;
        }

        onChange && onChange(tableFilters)
    }, [
        tableFilters,
        onChange
    ]);

    return (
        <TableFilter
            defaultActiveTab='originCountry'
            tabs={tableFilterTabs}
            onOkButtonClicked={
                onTableFilterOkButtonClicked
            }
        />
    )
}

export default withNamespaces()(FilteringComponent);